import type { ReactNode } from 'react';
export type QSelectItem<TLabel extends ReactNode = string, TValue = string> = {
  label: TLabel;
  value: TValue;
  options?: never;
};

export type QSelectGroup<
  TGroupLabel extends ReactNode = string,
  TLabel extends ReactNode = string,
  TValue = string,
> = {
  label: TGroupLabel;
  options: QSelectItem<TLabel, TValue>[];
  value?: never;
};

export const isGroup = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  thing: QSelectItem<any, unknown> | QSelectGroup<any, any, unknown>,
): thing is QSelectGroup => thing.options !== undefined;
